import { useState, useEffect } from "react";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import { ESTILO_BOTON_MODAL_ACEPTAR } from "../../../utils/const/estilos-const";
import sinAccesoCard from "../../../components/sin-acceso-card";
import { useTranslation } from "react-i18next";
import { obtenerListaProgramacionCamiones, actualizarIdEstadoViajeProgramacionCamiones } from "../../../api/api-programacion-camiones";
import { STRING_ID_TIPO_USUARIO_WEB, STRING_SUPER_ADMIN, STRING_ID_ROL_USUARIO_WEB } from "../../../utils/const/string-const";
import { obtenerPermisoRolUsuarioWeb } from "../../../api/api-permiso-rol-usuario-web";
import { PAGE_ID } from "../../usuarios/gestionar-rol-usuario-web/pages-const";
import { useToast, useProcessing } from "../../../context/ui-feedback-context";
import moment from "moment";
import Calendar from "../../../components/calendar";
import KanbanSolicitudProductoColumn from "../../../components/kanban-solicitud-producto-column";
import ModalConfigAccionesSolicitudKanban from "../../../components/modal-config-acciones-solicitud-kanban";
import DetalleRequerimientoSolicitudProductoComponent from "../../../components/detalle-requerimiento-solicitud-producto";
import {
    crearConfigAccionesSolicitudProductoDefault,
    guardarConfigAccionesSolicitudProducto,
    obtenerConfigAccionesSolicitudProducto,
    actualizarConfigAccionesSolicitudProducto,
} from "../../../api/api-solicitud-producto-config";
import {
    obtenerListaSolicitudProducto,
    aprobarSolicitudProducto,
    rechazarSolicitudProducto,
} from "../../../api/api-solicitud-producto";
import { actualizarIdEstadoSolicitudProducto } from "../../../api/api-solicitud-producto-config";

const SOLICITUD_COLUMN_ID = "solicitud-producto";

const parseSolicitudItem = (row) => {
    let respuestasParsed = [];
    try {
        if (typeof row?.respuestas === "string" && row.respuestas.trim().length > 0) {
            respuestasParsed = JSON.parse(row.respuestas);
        } else if (Array.isArray(row?.respuestas)) {
            respuestasParsed = row.respuestas;
        }
    } catch (err) {
        console.log("parseSolicitudItem err");
        console.log(err);
    }
    return {
        ...row,
        respuestasParsed,
    };
};

export default function ListarEstadoSolicitudProductoPage
    () {
    const idTipoUsuarioWeb = localStorage.getItem(STRING_ID_TIPO_USUARIO_WEB);
    const { t } = useTranslation();
    const [cargandoPage, setCargandoPage] = useState(true);
    // const [listaElementos, setListaElementos] = useState([]);
    const [elementoSelected, setElementoSelected] = useState(null);
    // const [permisos, setPermisos] = useState(null);
    const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(false);
    const [habilitadoSelected, setHabilitadoSelected] = useState(null);

    const [btnBuscar, setBtnBuscar] = useState(false);
    // const [btnNuevo, setBtnNuevo] = useState(false);
    // const [btnModificar, setBtnModificar] = useState(false);
    // const [btnDeshabilitar, setBtnDeshabilitar] = useState(false);
    // const [btnHabilitar, setBtnHabilitar] = useState(false);
    // const [btnExportar, setBtnExportar] = useState(false);

    // const [listaFormularioProgramacionCamiones, setListaFormularioProgramacionCamiones] = useState([]);
    const [listaFormularioSolicitudProducto, setListaFormularioSolicitudProducto] = useState([]);
    const [accionesConfig, setAccionesConfig] = useState(crearConfigAccionesSolicitudProductoDefault);
    const [modalConfigVisible, setModalConfigVisible] = useState(false);
    const [modalMotivoVisible, setModalMotivoVisible] = useState(false);
    const [motivoAction, setMotivoAction] = useState(null); // "aceptar" | "rechazar"
    const [motivoItem, setMotivoItem] = useState(null);
    const [motivoTexto, setMotivoTexto] = useState("");
    const [sendMotivoRequest, setSendMotivoRequest] = useState(false);

    // Toast only (success / error messages)
    const { showToast } = useToast();
    // Processing overlay only (loading while API runs)
    const { showProcessing, hideProcessing } = useProcessing();

    const [fechaInicio, setFechaInicio] = useState(moment().startOf('week').format('YYYY-MM-DD'));
    const [fechaFin, setFechaFin] = useState(moment().endOf('week').format('YYYY-MM-DD'));

    useEffect(() => {
        iniciar();
    }, []);

    const buildlistaFormularioSolicitudProducto = (solicitudes) => {
        return [
            {
                columnId: SOLICITUD_COLUMN_ID,
                title: null,
                items: solicitudes,
            },
        ];
    };

    const iniciar = async () => {
        let tieneAcceso = false;
        try {
            let objEnviar = {};
            objEnviar.fechaInicio = fechaInicio;
            objEnviar.fechaFin = fechaFin;
            objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : null;
            if (idTipoUsuarioWeb === STRING_SUPER_ADMIN) {
                tieneAcceso = true;
                setBtnBuscar(true);
                // setBtnNuevo(true);
                // setBtnModificar(true);
                // setBtnDeshabilitar(true);
                // setBtnHabilitar(true);
                // setBtnExportar(true);
            }
            if (idTipoUsuarioWeb !== STRING_SUPER_ADMIN) {
                const idRolUsuarioWeb = localStorage.getItem(STRING_ID_ROL_USUARIO_WEB);
                objEnviar.idRolUsuarioWeb = idRolUsuarioWeb;
                const response = await obtenerPermisoRolUsuarioWeb(objEnviar);
                if (response.error === false && response.data !== undefined) {
                    const permisos = JSON.parse(response.data.permisos);
                    // console.log('permisos');
                    // console.log(permisos);
                    if (Array.isArray(permisos) && permisos.length > 0) {
                        const manage = permisos.find(p => p.id === 8);
                        if (manage !== undefined && manage !== null) {
                            const permisosPage = manage.subMenu.find(p => p.value === PAGE_ID.GESTIONAR_RESPUESTA_SOLICITUD_PROGRAMACION_CAMIONES);
                            // console.log('permisosPage');
                            // console.log(permisosPage);
                            tieneAcceso = permisosPage.checked;
                            if (tieneAcceso === false) {
                                return;
                            }
                            const permisoBtnBuscar = permisosPage.acciones.find(a => a.value === 'btn_buscar');
                            // const permisoBtnNuevo = permisosPage.acciones.find(a => a.value === 'btn_nuevo');
                            // const permisoBtnModificar = permisosPage.acciones.find(a => a.value === 'btn_modificar');
                            // const permisoBtnDeshabilitar = permisosPage.acciones.find(a => a.value === 'btn_deshabilitar');
                            // const permisoBtnHabilitar = permisosPage.acciones.find(a => a.value === 'btn_habilitar');
                            // const permisoBtnExportar = permisosPage.acciones.find(a => a.value === 'btn_exportar');
                            setBtnBuscar(permisoBtnBuscar?.checked);
                            // setBtnNuevo(permisoBtnNuevo?.checked);
                            // setBtnModificar(permisoBtnModificar?.checked);
                            // setBtnDeshabilitar(permisoBtnDeshabilitar?.checked);
                            // setBtnHabilitar(permisoBtnHabilitar?.checked);
                            // setBtnExportar(permisoBtnExportar?.checked);
                        }
                    }
                }
            }
            if (tieneAcceso === true) {

                const [
                    listaSolicitudProducto,
                    responseConfig
                ] = await Promise.all([
                    obtenerListaSolicitudProducto(objEnviar, false, t),
                    obtenerConfigAccionesSolicitudProducto(),
                ]);
                const solicitudes = listaSolicitudProducto.map(parseSolicitudItem);
                setListaFormularioSolicitudProducto(buildlistaFormularioSolicitudProducto(solicitudes));
                // console.log('responseConfig');
                // console.log(responseConfig);
                setAccionesConfig(responseConfig.data);
            }
        } catch (err) {
            console.log('iniciar err');
            console.log(err);
        } finally {
            setCargandoPage(false);
            setTieneAccesoAlModulo(tieneAcceso);
        }
    };

    const reset = async () => {
        setCargandoPage(true);
        iniciar();
    };

    const handleSolicitudCardClick = (item) => {
        setElementoSelected(item);
    };

    const handleDetalleSaved = (updatedItem) => {
        setElementoSelected(updatedItem);
        setListaFormularioSolicitudProducto((prev) =>
            prev.map((column) => ({
                ...column,
                items: (column.items || []).map((card) =>
                    String(card.id) === String(updatedItem.id) ? updatedItem : card
                ),
            }))
        );
    };

    const recargarListaSolicitudProducto = async (selectedItemId) => {
        const objEnviar = {
            habilitado: habilitadoSelected?.value ?? null,
            fechaInicio,
            fechaFin,
        };

        const listaSolicitudProducto =
            await obtenerListaSolicitudProducto(objEnviar, false, t);
        const solicitudes = listaSolicitudProducto.map(parseSolicitudItem);

        setListaFormularioSolicitudProducto(buildlistaFormularioSolicitudProducto(solicitudes));
        setElementoSelected(
            solicitudes.find(
                (solicitud) => String(solicitud.id) === String(selectedItemId)
            ) ?? null
        );
    };

    const executeConfiguredAction = (action, item) => {
        setMotivoAction(action);
        setMotivoItem(item);
        setMotivoTexto("");
        setModalMotivoVisible(true);
    };

    const handleCancelMotivo = () => {
        setModalMotivoVisible(false);
        setMotivoAction(null);
        setMotivoItem(null);
        setMotivoTexto("");
    };

    const handleConfirmMotivo = async () => {
        const motivo = String(motivoTexto ?? "").trim();
        if (motivo.length === 0) {
            showToast(t("alert_debe_ingresar_motivo"), "error", 3000);
            return;
        }
        if (motivoItem?.id == null || motivoAction == null) {
            handleCancelMotivo();
            return;
        }

        const payload = { id: motivoItem.id, motivo };
        setSendMotivoRequest(true);
        showProcessing();
        const response =
            motivoAction === "aceptar"
                ? await aprobarSolicitudProducto(payload)
                : await rechazarSolicitudProducto(payload);

        if (response.error === true) {
            setSendMotivoRequest(false);
            hideProcessing();
            showToast(response.message || t("alert_no_se_pudo_crear"), "error", 3000);
            return;
        }

        const itemId = motivoItem.id;
        const wasAceptar = motivoAction === "aceptar";
        handleCancelMotivo();
        await recargarListaSolicitudProducto(itemId);
        setSendMotivoRequest(false);
        hideProcessing();

        showToast(
            wasAceptar
                ? t("alert_solicitud_aprobada")
                : t("alert_solicitud_rechazada"),
            wasAceptar ? "success" : "warning",
            3000
        );
    };

    const handleSaveConfig = async (config) => {
        const payload = {
            ...config,
            id: accionesConfig?.id ?? null,
            idKanban: SOLICITUD_COLUMN_ID,
        };
        showProcessing();
        const response = payload.id
            ? await actualizarConfigAccionesSolicitudProducto(payload)
            : await guardarConfigAccionesSolicitudProducto(payload);
        hideProcessing();
        if (response.error === false) {
            setAccionesConfig(response.data);
            setModalConfigVisible(false);
            showToast(t("label_guardar"), "success", 2000);
            return;
        }
        showToast(response.message, "error", 3000);
    };

    const render = () => {
        try {
            // console.log('listar correo render');
            if (cargandoPage === true) {
                return cargandoCard();
            }
            if (tieneAccesoAlModulo === false) {
                return sinAccesoCard();
            }
            return (
                <div className="max-w-7xl mx-auto px-4 lg:px-6">
                    <div className="flex items-center justify-between py-4">
                        <div>
                            <div className="flex items-center gap-2">
                                {/* <ArrowBack onClick={handleAtrasClick} /> */}
                                <h2 className="text-xl font-bold text-gray-900">{t("label_gestionar_solicitud_producto")}</h2>
                            </div>
                            <p className="text-sm text-gray-500">{t("label_administra_la_lista_de_estado_solicitud_producto")}</p>
                        </div>
                    </div>
                    <div className="grid grid-cols-12 gap-4">
                        <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">{t("label_fecha_inicio")}</label>
                            <Calendar
                                value={fechaInicio}
                                onChange={(date) => setFechaInicio(date)}
                                placeholder={t("placeholder_seleccione_fecha")}
                                id="fecha_inicio"
                                name="fecha_inicio"
                            />
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                            <label className="block text-sm font-medium text-gray-700 mb-2">{t("label_fecha_fin")}</label>
                            <Calendar
                                value={fechaFin}
                                onChange={(date) => setFechaFin(date)}
                                placeholder={t("placeholder_seleccione_fecha")}
                                id="fecha_fin"
                                name="fecha_fin"
                            />
                        </div>
                        {btnBuscar === true && (
                            <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                                <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                                    &nbsp;
                                </label>
                                <button
                                    type="button"
                                    className={ESTILO_BOTON_MODAL_ACEPTAR}
                                    onClick={() => { reset(); }}
                                >
                                    {t("label_buscar")}
                                </button>
                            </div>
                        )}
                    </div>
                    <br />
                    <div className="grid grid-cols-12 gap-4 items-start">
                        <div className="col-span-12 md:col-span-6 lg:col-span-4 xl:col-span-4">
                            {listaFormularioSolicitudProducto.map((column) => (
                                <KanbanSolicitudProductoColumn
                                    key={column.columnId}
                                    columnId={column.columnId}
                                    title={t("label_formulario_solicitud_producto")}
                                    items={column.items}
                                    onCardClick={handleSolicitudCardClick}
                                    onAcceptCard={(item) => executeConfiguredAction("aceptar", item)}
                                    onRejectCard={(item) => executeConfiguredAction("rechazar", item)}
                                    onConfigureActions={() => setModalConfigVisible(true)}
                                    selectedItemId={elementoSelected?.id ?? null}
                                    emptyLabel={t("label_sin_datos")}
                                />
                            ))}
                        </div>
                        <div className="col-span-12 md:col-span-6 lg:col-span-8 xl:col-span-8">
                            <div className="bg-white border border-gray-200 rounded-lg p-4 min-h-[300px]">
                                <DetalleRequerimientoSolicitudProductoComponent
                                    item={elementoSelected}
                                    onSaved={handleDetalleSaved}
                                />
                            </div>
                        </div>
                    </div>
                    <br />

                    <ModalConfigAccionesSolicitudKanban
                        isOpen={modalConfigVisible}
                        initialConfig={accionesConfig}
                        onCancel={() => setModalConfigVisible(false)}
                        onSave={handleSaveConfig}
                    />

                    {modalMotivoVisible && (
                        <div className="fixed z-50 top-0 left-0 right-0 bottom-0 flex items-center justify-center">
                            <div
                                className="fixed inset-0 bg-gray-500 opacity-75"
                                onClick={() => {
                                    if (!sendMotivoRequest) handleCancelMotivo();
                                }}
                            ></div>
                            <div className="bg-white w-11/12 md:max-w-md mx-auto rounded shadow-lg z-50 overflow-hidden">
                                <div className="px-6 py-4 border-b border-gray-200">
                                    <p className="text-lg font-semibold text-gray-900">
                                        {motivoAction === "aceptar"
                                            ? t("label_aprobar_solicitud")
                                            : t("label_rechazar_solicitud")}
                                    </p>
                                    {motivoItem?.descripcion ? (
                                        <p className="text-xs text-gray-500 mt-1 truncate">
                                            {motivoItem.descripcion}
                                        </p>
                                    ) : null}
                                </div>
                                <div className="px-6 py-4">
                                    <label className="block text-sm font-medium text-gray-700 mb-1">
                                        {t("label_motivo")}
                                        <span className="text-red-500 ml-1">*</span>
                                    </label>
                                    <textarea
                                        value={motivoTexto}
                                        onChange={(e) => setMotivoTexto(e.target.value)}
                                        rows={4}
                                        maxLength={512}
                                        placeholder={t("placeholder_ingrese_motivo")}
                                        className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                                        disabled={sendMotivoRequest}
                                        autoFocus
                                    />
                                    <p className="text-xs text-gray-500 flex justify-end mt-1">
                                        {motivoTexto.length}/512
                                    </p>
                                </div>
                                <div className="px-6 py-3 border-t border-gray-200 flex justify-end gap-2">
                                    <button
                                        type="button"
                                        className="inline-flex justify-center px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 border border-transparent rounded-md hover:bg-gray-200 disabled:opacity-50"
                                        onClick={handleCancelMotivo}
                                        disabled={sendMotivoRequest}
                                    >
                                        {t("label_cancelar")}
                                    </button>
                                    <button
                                        type="button"
                                        className={`inline-flex justify-center px-4 py-2 text-sm font-medium text-white border border-transparent rounded-md disabled:opacity-50 ${motivoAction === "aceptar"
                                            ? "bg-green-600 hover:bg-green-700"
                                            : "bg-red-600 hover:bg-red-700"
                                            }`}
                                        onClick={handleConfirmMotivo}
                                        disabled={sendMotivoRequest}
                                    >
                                        {motivoAction === "aceptar"
                                            ? t("label_aprobar_solicitud")
                                            : t("label_rechazar_solicitud")}
                                    </button>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            );
        } catch (err) {
            console.log('ListarPais render err');
            console.log(err);
            return (
                <div><label>{JSON.stringify(err)}</label></div>
            );
        }
    }

    return render();
}
